import { render, staticRenderFns } from "./InterDirectorInfo.vue?vue&type=template&id=eb7d7090"
import script from "./InterDirectorInfo.vue?vue&type=script&lang=js"
export * from "./InterDirectorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports